var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.7593135480231968"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.9799 0H290L204.02 141H0L85.9799 0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.9799 0H290L204.02 141H0L85.9799 0Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(1.0344827586206897, 2.127659574468085)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9799 0H290L204.02 141H0L85.9799 0Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.7593135480231968)",
    transform: "scale(1.0344827586206897, 2.127659574468085)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg51);
export default __webpack_public_path__ + "static/media/51.220fa770969ca5706b536779dd61c9b4.svg";
export { ForwardRef as ReactComponent };